import React from 'react'


const HTML = ({value}) => {
    return <div dangerouslySetInnerHTML={{ __html: value }} />
}

export default HTML